import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { LANGUAGES, translations } from "../i18n/translations";

const LanguageContext = createContext(null);

const mergeDeep = (base, over) => {
  if (Array.isArray(base)) return over ?? base;
  if (typeof base !== "object" || base === null) return over ?? base;
  const out = { ...base };
  for (const k of Object.keys(base)) {
    if (over && k in over) out[k] = mergeDeep(base[k], over[k]);
  }
  return out;
};

const PRIORITY = ["el", "en", "it"]; // Greek first (brand home market), then English, then Italian

const detectLang = () => {
  const urlLang = new URLSearchParams(window.location.search).get("lang");
  if (urlLang && LANGUAGES.some((l) => l.code === urlLang)) return urlLang;
  const saved = localStorage.getItem("ap-lang");
  if (saved && LANGUAGES.some((l) => l.code === saved)) return saved;
  const codes = (navigator.languages || [navigator.language || ""]).map((l) => (l || "").split("-")[0].toLowerCase());
  for (const p of PRIORITY) if (codes.includes(p)) return p;
  const other = codes.find((c) => LANGUAGES.some((l) => l.code === c));
  return other || "el";
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(detectLang);

  useEffect(() => {
    const meta = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
    document.documentElement.lang = lang;
    document.documentElement.dir = meta.dir;
    localStorage.setItem("ap-lang", lang);
  }, [lang]);

  const t = mergeDeep(translations.en, translations[lang] || {});
  const dir = (LANGUAGES.find((l) => l.code === lang) || {}).dir || "ltr";

  const localize = useCallback(
    (i18nObj) => {
      if (!i18nObj) return {};
      return { ...i18nObj.en, ...(i18nObj[lang] || {}) };
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, dir, localize, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
